import React from "react";
import { Box, Grid, FormControlLabel, IconButton } from "@mui/material";
import { FieldArrayRenderProps, FormikProps, useFormikContext } from "formik";
import { Data } from "../../../../../store/terminal/types";
import { Delete } from "@mui/icons-material";
import CustomizedCheckbox from "./../../../../../common/formElements/Checkbox";
import { get } from "lodash";
import TextInput from "../../../../../common/formElements/TextInput";

interface AdditionalDataInput {
  arrayHelpers: FieldArrayRenderProps;
  index: number;
  dataIndex: number;
  isUpdateAllowed?: boolean;
}

const AdditionalDataInput = (props: AdditionalDataInput) => {
  const { arrayHelpers, index, dataIndex, isUpdateAllowed } = props;
  const formikProps = useFormikContext<FormikProps<Data>>();
  const { setFieldValue } = formikProps;
  const values = (formikProps.values as unknown) as Data;

  return (
    <>
      <Grid item xs={12} md={4}>
        <Box>
          <TextInput
            fieldname={`attributes.Processor[${index}].AdditionalData[${dataIndex}].Tag`}
            label="Tag"
            disabled={!isUpdateAllowed}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={4}>
        <Box>
          <TextInput
            fieldname={`attributes.Processor[${index}].AdditionalData[${dataIndex}].Value`}
            label="Value"
            disabled={!isUpdateAllowed}
          />
        </Box>
      </Grid>
      <Grid item xs={12} md={4}>
        <Box>
          <FormControlLabel
            control={
              <CustomizedCheckbox
                checked={
                  values.attributes?.Processor &&
                  values.attributes?.Processor[index]?.AdditionalData &&
                  values.attributes?.Processor[index]?.AdditionalData[dataIndex]?.Encrypted
                }
                onChange={(
                  _event: React.FormEvent<HTMLInputElement>,
                  data: boolean
                ) => {
                  setFieldValue(
                    `attributes.Processor[${index}].AdditionalData[${dataIndex}].Encrypted`,
                    data
                  );
                }}
                name={`attributes.Processor[${index}].AdditionalData[${dataIndex}].Encrypted`}
              />
            }
            label="Encrypted"
            disabled={
              !get(
                values,
                `attributes.Processor[${index}].AdditionalData[${dataIndex}].isNew`
              ) || !isUpdateAllowed
            }
          />

          <IconButton
            aria-label="delete"
            onClick={(): void => {
              arrayHelpers.remove(dataIndex);
            }}
            disabled={!isUpdateAllowed}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      </Grid>
    </>
  );
};

export default AdditionalDataInput;
